import React from 'react';
import { connect } from 'react-redux';
import withRouter from 'src/config/withRouter';
import { update_dialog, closeUpgradeDialog } from '../store/action';
import { Dialog } from '@mui/material';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@mui/styles';

const styles = (theme) => {
    return{
    dialogContainer:{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding:'10px'
    },

    dialogHeader:{
        fontSize: '21px',
        color: '#000',
        textAlign: 'center !important',
        padding:'10px',
    },

    button:{
        textDecoration: 'none',
        border: 'none',
        outline: 'none',
        backgroundColor: '#0F467A',
        color: '#fff',
        width: '80%',
        padding: '12px 0px',
        borderRadius: '10px',
        cursor: 'pointer',
        textTransform: 'uppercase',
        textAlign: 'center',
    },

    cancelBtn:{
        textDecoration: 'none',
        border: 'none',
        outline: 'none',
        color: 'grey',
        backgroundColor: 'transparent',
        cursor: 'pointer',
        padding: '12px 0px 0px 0px',
        borderRadius: '10px',
        textTransform: 'uppercase',
        textAlign: 'center',
    },

    dialogRoot:{
        zIndex: '1111111 !important'
    }
}};

class UpgradeDialog extends React.Component {
    _isMounted = false;

    componentWillUnmount() {
        this._isMounted = false;
    }
    
    handleClose = () => {
        this.props.set_dialog(false)
	}

    upgradeRedirect = async () => {
        this._isMounted = true;
        if(this._isMounted) {
            this.props.set_dialog(false)
            setTimeout(()=> this.props._closeUpgradeDialog(true),500)
        }
    }
    
    render() {
        const { classes, t, i18n , tReady, dialog, dialogType, ...other } = this.props;
        const isRTL = i18n.translator.language;
        const ar = "'Cairo', sans-serif";
        const en = "'Poppins', sans-serif";
        const fontFamily = isRTL === 'ar' ? ar : en;
        return (
            <Dialog maxWidth='sm' onClose={this.handleClose} classes={{root:classes.dialogRoot}} aria-labelledby="alertDialog" {...other} open={dialog}>
            <div className={classes.dialogContainer}>
                <div className={classes.dialogContainer}>
                    <span className={classes.dialogHeader} style={{fontFamily}}>{t('upgrade-dialog.name')}</span>
                    <span style={{textAlign:'center',padding:'10px',fontFamily}}>{dialogType === 'service' ? t('upgrade-dialog.serviceInfo') : 'You need upgrade to use more features'}</span>
                    <div className={classes.button} onClick={this.upgradeRedirect} style={{fontFamily}}>{t('upgrade-dialog.up')}</div>
                    <div className={classes.cancelBtn} onClick={this.handleClose} style={{fontFamily}}>{t('upgrade-dialog.can')}</div>
                </div>
            </div>
            </Dialog>
        );
    }
}

const mapStateToProps = state => {
    return{
      dialog: state.dialog,
      dialogType: state.dialogType
    }
}
  
const mapDispatchToProps = dispatch => {
    return {
        set_dialog : status => dispatch(update_dialog(status)),
        _closeUpgradeDialog: (event) => dispatch(closeUpgradeDialog(event))
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)
(withStyles(styles)
(withTranslation('common')(UpgradeDialog))));